import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Breadcrumbs, Link, Typography, Stack, IconButton, Popover } from '@mui/material';
import { useParams } from 'react-router-dom';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PortalPageHeader = ({
  breadcrumbs = null,
  action = null,
  banner = null,
  title = '',
  id = '',
  columnBreakpoint = 'xs',
  logo,
  logoAlt,
  tooltip,
}) => {
  const params = useParams();
  const [tooltipAnchor, setTooltipAnchor] = useState(null);
  const isTooltipOpen = Boolean(tooltipAnchor);
  const idPrefix = id || (title ? title.replace(/\s+/g, '') : '');

  // Build direction object for Stack
  const nextBreakpoint =
    {
      xs: 'sm',
      sm: 'md',
      md: 'lg',
      lg: 'xl',
      xl: 'xxl',
      xxl: null,
    }[columnBreakpoint] || 'sm';

  const direction = nextBreakpoint
    ? { [columnBreakpoint]: 'column', [nextBreakpoint]: 'row' }
    : { [columnBreakpoint]: 'column' };

  // make breadcrumbs from path if not sent as array
  let crumbs = [];
  if (Array.isArray(breadcrumbs) && breadcrumbs.length > 0) {
    crumbs = breadcrumbs;
  } else {
    let paths = window.location.pathname.split('/').filter((path) => path !== '');
    paths = paths.slice(0, Object.keys(params).length ? -Object.keys(params).length : paths.length);

    //start with dashboard
    crumbs.push({ title: 'Dashboard', href: '/' });

    let pathToSegment = '';
    paths.forEach((segment, index) => {
      pathToSegment += `/${segment}`;

      if (index < paths.length - 1) {
        //split by hyphens/underscores and capitalize each word
        const formattedTitle = segment
          .split(/[-_]/)
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');

        crumbs.push({ title: formattedTitle, href: pathToSegment });
      }
    });
  }

  return (
    <>
      {banner && <div>{banner}</div>}
      {logo ? (
        <img src={logo} alt={logoAlt} />
      ) : (
        <Stack
          direction={direction}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}
        >
          <Box sx={{ width: '100%' }}>
            <Box display="flex" flexDirection="row" alignItems="center" justifyItems="center">
              <Typography component="h2" id={`${idPrefix}__h2_pageTitle`}>
                {title}
              </Typography>

              {tooltip && (
                <>
                  <IconButton
                    onClick={(e) => setTooltipAnchor(e.currentTarget)}
                    aria-label={`Open ${title} information`}
                    id={`${idPrefix}__button_info`}
                  >
                    <FontAwesomeIcon icon={faCircleInfo} />
                  </IconButton>

                  <Popover
                    id={`${id}__popover_info`}
                    open={isTooltipOpen}
                    anchorEl={tooltipAnchor}
                    onClose={() => setTooltipAnchor(null)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    PaperProps={{ sx: { width: 'min(52rem, calc(100vw - 2rem))', p: 2 } }}
                  >
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <FontAwesomeIcon icon={faCircleInfo} />
                        <Typography component="h3" variant="h5">
                          {title}
                        </Typography>
                      </Box>
                      <IconButton
                        onClick={() => setTooltipAnchor(null)}
                        aria-label="Close information tooltip"
                        id={`${id}__button_closeInfo`}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </IconButton>
                    </Box>
                    <Box id={`${id}__popover_content`}>{tooltip}</Box>
                  </Popover>
                </>
              )}
            </Box>

            {crumbs.length > 0 && (
              <Breadcrumbs
                className="myOdu__breadcrumbs mb-0"
                id={`${idPrefix}__breadCrumbs`}
                aria-label="breadcrumb"
              >
                {crumbs.map((crumb, i) => (
                  <Link
                    component={RouterLink}
                    key={i}
                    id={`${idPrefix}__breadCrumbs_${i}`}
                    underline="hover"
                    to={crumb.href || '#'}
                  >
                    {crumb.title}
                    {console.log('crumb title:', crumb.title)}
                  </Link>
                ))}
                <Typography id={`${idPrefix}__breadCrumbs_currentPage`}>{title}</Typography>
              </Breadcrumbs>
            )}
          </Box>
          {action ? (
            <Box textAlign="right" justifyContent="flex-end" className="w-100">
              {action}
            </Box>
          ) : null}
        </Stack>
      )}
    </>
  );
};

export default PortalPageHeader;
